<template>
	<v-expansion-panels class="elevation-0 pt-6">
		<v-expansion-panel class="elevation-0 table" @click.stop="panelKey++">
			<v-expansion-panel-header class="py-0 elevation-0">
				<v-row v-if="project" class="pl-4 resize">
					<v-col cols="6" class="py-0">
						<v-row class="row-left">
							<v-col cols="4" md="3" lg="4" class="py-2 pt-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("name") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 pt-1 my-0 project-name">
								<compress-string :name="project.name" :widthAvailable="30" />
							</v-col>
							<v-col cols="4" md="3" lg="4" class="pt-2 my-0 header">
								<p class="py-1 ma-0">{{ $t("status") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="pt-1 my-0">
								<status-box
									:status="project.status"
									:projectId="project.id"
									:isProgress="true"
									class="status"
									:progressValue="project.progress"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6" class="py-0">
						<v-row class="">
							<v-col cols="4" md="4" lg="4" class="py-1 my-0 header">
								<p class="pa-0 ma-0">{{ $t("description") }}</p>
							</v-col>
							<v-col cols="8" md="8" lg="8" class="py-1 my-0 description">
								<p>
									{{
										project.description !== ""
											? project.description
											: $t("noData")
									}}
								</p>
							</v-col>
							<v-col cols="4" md="4" lg="4" class="pt-7 my-0 header">
								<p class="pa-0 ma-0" v-if="project.organismName !== null">
									{{ $t("organism") }}
								</p>
								<p class="pa-0 ma-0" v-if="project.organismName === null">
									{{ $t("projectDownload") }}
								</p>
							</v-col>
							<v-col cols="8" md="8" lg="8" class="pt-7 my-0 description">
								<p class="pa-0 ma-0" v-if="project.organismName !== null">
									{{ project.organismName }}
								</p>
								<div v-if="project.organismName === null">
									<p
										v-for="dn in downloaders"
										v-bind:key="dn"
										class="pa-0 ma-0"
									>
										{{ dn }}
									</p>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-expansion-panel-header>

			<v-expansion-panel-content class="expand" :key="panelKey">
				<v-row class="pl-4 resize" v-if="project">
					<v-col cols="6" class="py-0">
						<v-row>
							<v-col cols="4" md="3" lg="4" class="pb-2 pt-0 my-0 header ">
								<p class="pa-0 ma-0">{{ $t("submittedDate") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">{{ creationString }}</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("expirationDate") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<ExpirationCounter :date="project.expirationDate" />
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header ">
								<p class="pa-0 ma-0">{{ $t("generalCover") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">
									{{
										project.generalCover ? project.generalCover : $t("noData")
									}}
								</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("deedDateTime") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">{{ deedDateTime }}</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("referenceNumber") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">
									{{
										project.referenceNumber
											? project.referenceNumber
											: $t("noData")
									}}
								</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("crimeType") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">
									{{
										project.crimeType !== "noData"
											? project.crimeType
											: $t("noData")
									}}
								</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("size") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0">
								<p
									class="pa-0 ma-0"
									v-if="
										project.status === 'Finished' ||
											project.status === 'Approved' ||
											project.status === 'Denied' ||
											project.status === 'Expired'
									"
								>
									{{ sizeToString }}
								</p>
								<p class="pa-0 ma-0" v-else>-</p>
							</v-col>
							<v-col cols="4" md="3" lg="4" class="py-2 my-0 header">
								<p class="pa-0 ma-0">{{ $t("submittedBy") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 description">
								<p class="pa-0 ma-0">{{ project.startedBy }}</p>
							</v-col>
							<v-col
								v-if="project.secondaryOrganisms.length > 0"
								cols="4"
								md="3"
								lg="4"
								class="py-2 my-0 header"
							>
								<p class="pa-0 ma-0">{{ $t("sharedWith") }}</p>
							</v-col>
							<v-col
								v-if="project.secondaryOrganisms.length > 0"
								cols="8"
								md="9"
								lg="8"
								class="py-2 my-0 description"
							>
								{{
									project.secondaryOrganisms
										.map((secondary) => secondary.name)
										.join(", ")
								}}
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6" class="col-info pt-0">
						<v-row v-if="project.cut" class="pt-0" justify="start">
							<v-col
								cols="4"
								md="3"
								lg="4"
								class="py-2 my-0 header resize-content"
							>
								<p class="pa-0 ma-0">{{ $t("cut") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 resize-content">
								<p class="pa-0 ma-0">{{ $t("yes") }}</p>
							</v-col>
							<v-col
								cols="4"
								md="3"
								lg="4"
								class="py-2 my-0 header resize-content"
							>
								<p class="pa-0 ma-0">{{ $t("cutBy") }}</p>
							</v-col>
							<v-col cols="8" md="9" lg="8" class="py-2 my-0 resize-content">
								<p class="pa-0 ma-0">{{ $t(project.cutBy) }}</p>
							</v-col>
							<v-col
								cols="4"
								md="3"
								lg="4"
								class="py-2 my-0 header resize-content"
							>
								<p class="pa-0 ma-0">{{ $t("cutSize") }}</p>
							</v-col>
							<v-col
								v-if="project.cutBy === 'size'"
								cols="8"
								md="9"
								lg="8"
								class="py-2 my-0 resize-content"
							>
								<p class="pa-0 ma-0">
									{{ this.returnCutSize(project.cutSize) }}
								</p>
							</v-col>
							<v-col
								v-else
								cols="8"
								md="9"
								lg="8"
								class="py-2 my-0 resize-content"
							>
								<p class="pa-0 ma-0">
									{{ project.cutSize }} {{ $tc("cutTime") }}
								</p>
							</v-col>
						</v-row>
						<v-row class="pt-0" justify="start">
							<v-col
								cols="4"
								md="3"
								lg="4"
								class="py-2 my-0 header resize-content"
							>
								<p class="pa-0 ma-0">{{ $t("location") }}</p>
							</v-col>
							<v-col
								cols="8"
								md="9"
								lg="8"
								class="py-2 my-0 description resize-content"
							>
								<p class="pa-0 ma-0">
									{{ project.location ? project.location : $t("noData") }}
								</p>
							</v-col>
							<v-col
								cols="4"
								md="4"
								lg="4"
								class="py-2 my-0 header pl-0 info-geo"
							>
								<p class="pa-0 ma-0">{{ $t("geographicInfo") }}</p>
							</v-col>
							<v-col cols="8" md="8" lg="8" class="py-2 my-0 pl-0 description">
								<map-display
									class="map-table"
									:markers="this.project.extractions"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6" class="col-info">
						<v-row class="pt-0" justify="start"> </v-row>
					</v-col>
				</v-row>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
export default {
	props: {
		project: Object,
	},
	components: {
		MapDisplay: () => import("@/components/base/Map"),
		ExpirationCounter: () =>
			import("@/views/mainView/components/ExpirationCounter"),
		CompressString: () => import("@/components/base/CompressString"),
	},

	data() {
		return {
			extractions: Array,
			panelKey: 0,
		};
	},
	mounted() {},
	computed: {
		userCanAudit: {
			get() {
				return (
					this.$store.getters.getRole == "auditor" ||
					this.$store.getters.getRole == "admin"
				);
			},
		},
		userCanLegalAudit: {
			get() {
				return (
					this.$store.getters.getRole == "legal_auditor" ||
					this.$store.getters.getRole == "admin"
				);
			},
		},
		creationString: {
			get() {
				var aux = new Date(this.project.creationDate);
				return new Date(aux.toString() + " UTC").toLocaleString();
			},
		},
		deedDateTime: {
			get() {
				var aux = new Date(this.project.deedDateTime);
				if (this.project.deedDateTime != "0001-01-01T00:00:00") {
					return new Date(aux.toString() + " UTC").toLocaleString();
				} else {
					return this.$t("noData");
				}
			},
		},
		sizeToString: {
			get() {
				return this.returnSize(this.size);
			},
		},
		size: {
			get() {
				var a = 0;
				if (
					this.project.status === "Finished" ||
					this.project.status === "Approved" ||
					this.project.status === "Denied" ||
					this.project.status === "Expired"
				) {
					this.project.extractions.forEach((extr) => {
						a += extr.totalSize;
					});
					return a;
				}
				return a;
			},
		},
		downloaders: {
			get() {
				return this.project.downloaders;
			},
		},
	},
	methods: {
		returnSize(value) {
			var a = value / 1000000;
			if (a < 1000) {
				return a.toFixed(2).toString() + " MB";
			} else {
				return (a / 1000).toFixed(2).toString() + " GB";
			}
		},
		returnCutSize(a) {
			if (a < 1000) {
				return a.toString() + " MB";
			} else {
				return (a / 1000).toFixed(2).toString() + " GB";
			}
		},
	},
};
</script>

<style>
.v-expansion-panel::before {
	z-index: 0 !important;
	box-shadow: none !important;
}

.map-table {
	height: 185px !important;
	width: 320px !important;
	margin-left: 0 !important;
	padding-left: 0 !important;
}
.table {
	font-family: "Roboto", "sans-serif";
	border: 1px solid #eee;
	border-radius: 10px;
	width: 90%;
	margin-left: 18px !important;
	font-size: 14px;
}
.v-expansion-panels {
	width: 95% !important;
	margin-left: 10px !important;
	border-radius: 10px;
	z-index: 0 !important;
}
.v-expansion-panel {
	padding-top: 18px;
	border-radius: 10px !important;
}
.header {
	font-weight: bold;
	font-size: 14px;
}
.description {
	color: #91919c;
}
.project-name {
	color: #0d5ae5;
	font-weight: bold;
}
.resize-content {
	padding-left: 0px !important;
}
@media (max-width: 960px) {
	.table {
		font-size: 12px;
		margin-left: 0px !important;
	}
	.resize {
		font-size: 12px;
	}
	.status {
		font-size: 12px !important;
	}
	.map-table {
		width: 260px !important;
	}
}
@media (max-width: 875px) {
	.resize .col-6 {
		flex: 0 0 100% !important;
		max-width: 100% !important;
		padding-left: 0 !important;
	}
	.resize-content {
		padding-left: 12px !important;
	}
	.info-geo {
		margin-left: 13px;
	}
	.row.info-geo {
		justify-content: start !important;
	}
}
@media (max-width: 600px) {
	.header {
		font-size: 11px;
		padding-left: 2px !important;
		padding-right: 2px !important;
	}
	.table {
		font-size: 10px;
	}
	.resize {
		font-size: 10px;
	}

	.status {
		font-size: 10px !important;
	}
	.panel {
		padding-right: 20px !important;
	}
	.row {
		justify-content: start !important;
	}
	.info-geo {
		margin-left: 2px;
	}
	.map-table {
		width: 230px !important;
	}
}
</style>
